module.exports = __webpack_public_path__ + "img/partner_img22.bb90fdc5.png";